define(["dojo/i18n", "/local/buildagent/work/7bfdef0d49469377/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"/local/buildagent/work/7bfdef0d49469377/target/debug/2P/derived/ui/mw-filebrowser/l10n/nls/FileBrowserResources.js?absMid=mw-filebrowser/l10n/nls/FileBrowserResources"
], function(loader, runner) {
   return runner(loader, "mw-filebrowser/l10n/nls/FileBrowserResources", __webpack_require__.dj.c(), true);
});